import BaseAPI from './base';

class DemarchesAPI extends BaseAPI {
  getFlow(slug: string) {
    return this.get(`/api/web/v1/demarches/${slug}`, {});
  }

  createContact(slug: string, contact: Record<string, unknown>) {
    return this.post(`/api/web/v1/demarches/${slug}/contacts`, { contact });
  }
}

export default new DemarchesAPI();
